<template>
  <BbPopup v-model="isOpened" :showCloseIcon="true" contentClass="add-shared-collection-dialog">
    <template #popup-header>
      <TextBody
        tag="span"
        i18n-key="collections.sharedCollection.addSharedCollection"
        :body-type="3"
        weight="medium"
      ></TextBody>
    </template>
    <div class="add-share-collection-container" v-if="collection && isValid">
      <TextBody
        tag="span"
        i18n-key="collections.sharedCollection.confirmationMessage"
        :body-type="1"
        weight="medium"
      ></TextBody>
      <div class="collection-details">
        <div class="image-header">
          <div class="image-container">
            <img :src="thumbUrl" alt="thumb" />
          </div>
        </div>
        <div class="title-container">
          <span class="collection-title">{{ collection.collectionName || '' }}</span>
          <div class="collection-subdetail-container">
            <span>{{ collection.documents.length + ' documents' }}</span>
            <span class="bullet">•</span>
            <span>{{ calculatePassedTime(collection.modifiedAt) }}</span>
          </div>
        </div>
      </div>
      <div class="actions">
        <BbBtn type="secondary" @click="closePopup">
          <TextBody i18n-key="common.cancel" />
        </BbBtn>
        <BbBtn @click="createCollection" color="#6222e3">
          <TextBody i18n-key="collections.sharedCollection.addCollection"></TextBody>
        </BbBtn>
      </div>
    </div>
    <div v-else>
      <TextBody :text="message"></TextBody>
    </div>
  </BbPopup>
</template>
<script>
import { computed, ref, watch } from 'vue';
import { calculatePassedTime } from '~/utils/date-utils';
import useCollections from '~/composables/useCollections';
import useDocuments from '~/composables/useDocuments';
import TextBody from '~/components/common/TextBody';

export default {
  components: { TextBody },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    sharedLinkId: {
      type: String,
      default: '',
    },
    collection: {
      type: Object,
      default: () => {},
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { createSharedCollection } = useCollections();
    const { getDocumentThumbs } = useDocuments();
    const closePopup = (val) => {
      emit('close-popup', val);
    };
    const isOpened = computed({
      get: () => props.open,
      set: (val) => closePopup(val),
    });
    const thumbUrl = ref('');

    const createCollection = async () => {
      await createSharedCollection(props.sharedLinkId, props.collection.collectionId);
      closePopup();
    };
    watch(isOpened, async (newVal) => {
      if (newVal && props.collection?.documents?.length) {
        const thumbResponse = await getDocumentThumbs({
          documents: [
            {
              id: props.collection.documents[props.collection.documents.length - 1],
              pages: [1],
            },
          ],
        });
        thumbUrl.value = thumbResponse[0]?.pages[1]?.small || '';
      }
      //}
    });
    return {
      calculatePassedTime,
      closePopup,
      createCollection,
      isOpened,
      thumbUrl,
    };
  },
};
</script>
<style scoped lang="scss">
.add-share-collection-container {
  display: flex;
  flex-direction: column;

  .actions {
    display: flex;
    padding-top: $bb-spacing-3;
    gap: $bb-spacing-2;
    justify-content: flex-end;
  }

  .collection-details {
    display: flex;
    flex-direction: row;
    padding-top: $bb-spacing-3;

    .image-header {
      display: flex;
      align-items: center;
      padding-right: $bb-spacing-3;

      .image-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between; /* Aligns children (start, content, end) */
        border-radius: $bb-spacing-1;
        background-color: $bb-neutral-5;
        min-width: 64px;
        max-width: 64px;
        height: 50px;
        align-items: flex-start;
        gap: $bb-spacing-1;

        img {
          max-width: 60px;
          max-height: 48px;
          align-self: center;
        }
      }
    }

    .title-container {
      display: flex;
      flex-direction: column;

      .collection-title {
        @include bb-medium-text-styles('md');
        line-height: $bb-spacing-5;
      }

      .collection-subdetail-container {
        display: flex;

        span {
          @include bb-regular-text-styles('xs');
          color: $bb-neutral-3;
          letter-spacing: 0.1px;
          font-size: 13px;
        }

        .bullet {
          margin: 0 $bb-spacing-1;
        }
      }
    }
  }
}

.share-link-actions {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-3;
}
</style>
